import LightingIcon from "../../../assets/icons/lighting.png";
import SparkleIcon from "../../../assets/icons/sparkle.png";
import LockIcon from "../../../assets/icons/lock.png";
import HeartIcon from "../../../assets/icons/heart.png";
import MoonIcon from "../../../assets/icons/moon.png";
import SunIcon from "../../../assets/icons/sun.png";

export const expertiseTitleData = [
  {
    title: "Innovate and Create",
  },
  {
    title: "Showcasing My Development Expertise",
  },
];

export const expertiseExperienceData = [
  {
    icon: LightingIcon,
    title: "Frontend Skills",
    describe:
      "Proficient in HTML, CSS, SCSS, SASS, JavaScript, TypeScript, React.js, Vite.js, Next.js.",
  },
  {
    icon: SparkleIcon,
    title: "Backend Skills",
    describe:
      "Experience with Node.js, Express, and MongoDB for building robust backend solutions.",
  },
  {
    icon: LockIcon,
    title: "Mobile Apps",
    describe:
      "Creating seamless mobile applications using React Native and Expo.",
  },
  {
    icon: HeartIcon,
    title: "150+ Projects",
    describe:
      "Successfully completed over 150 projects, delivering quality and efficiency.",
  },
  {
    icon: MoonIcon,
    title: "Design Tools",
    describe:
      "Utilize Figma for designing and implementing creative templates.",
  },
  {
    icon: SunIcon,
    title: "Career Goal",
    describe:
      "Aiming to join a forward-thinking organization to drive innovation and contribute to success.",
  },
];
